import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import { Typography } from '@material-ui/core';
import { useGetMyBooksQuery } from '../store/apiSlice';
import React, { useRef, useState } from 'react';

import { PageNav } from '../components/pageNav';
import { Helmet } from 'react-helmet-async';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { Skeleton } from '@material-ui/lab/';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
  grid: {
    borderColor: theme.palette.secondary,
    borderBottom: '1px solid',
    marginTop: theme.spacing(1),
  },
  flex: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
}));

function NewTitles() {
  const classes = useStyles();
  const [pageInput, setPageInput] = useState(1);

  const { data: bookData, isFetching } = useGetMyBooksQuery({
    page: pageInput,
  });

  const firstResultRef = useRef(null);

  const handlePageMove = (sign) => () => {
    setPageInput((prevState) => prevState + 1 * sign);
  };

  const handleInputChange = (e) => {
    e.persist();
    const newValue = Math.min(
      Math.max(e.target.value, 1),
      bookData?.pageCount || pageInput
    );
    setPageInput(newValue);
  };

  let books = bookData?.books || Array.from({ length: 20 });

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Helmet>
        <title>Моите книги</title>
      </Helmet>

      <Container maxWidth="lg" className={classes.container}>
        <Paper className={classes.paper}>
          <Typography
            className={classes.title}
            component="h1"
            variant="h4"
            role="alert"
          >
            Моите книги
          </Typography>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="Моите книги">
              <TableHead>
                <TableRow>
                  <TableCell>Заглавие</TableCell>
                  <TableCell>Автор</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {books.map((book, index) => (
                  <TableRow key={index}>
                    <TableCell scope="row">
                      {!isFetching ? (
                        <Link
                          ref={firstResultRef}
                          to={`../catalogue/${book.id}`}
                        >
                          {book.title}
                        </Link>
                      ) : (
                        <Skeleton width={'25vw'} />
                      )}
                    </TableCell>
                    <TableCell align="left">
                      {!isFetching ? (
                        book.author?.name
                      ) : (
                        <Skeleton width={'25vw'} />
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {books.length ? (
            <PageNav
              isFetching={isFetching}
              maxPage={bookData?.pageCount}
              handlePageMove={handlePageMove}
              pageInput={pageInput}
              handleInputChange={handleInputChange}
            />
          ) : (
            <Typography>Няма намерени книги.</Typography>
          )}
        </Paper>
      </Container>
    </div>
  );
}

export default NewTitles;
